import {
  DynamicTableBreakpoints,
  DynamicTableColumnTypes,
  DynamicTableSortDirection,
  DynamicTableVariantsDef,
} from '../../interfaces/dynamic-table.interface';

const DEFAULT_PAGINATION = {
  paginatable: true,
  showEdgeButtons: true,
  size: 10,
  options: [10, 20, 30],
};

export const PRINCIPALS_BROKER_CONFIG_DEFAULT: DynamicTableVariantsDef = {
  columns: {
    name: {
      id: 'name',
      label: $localize`Principal Name`,
      type: DynamicTableColumnTypes.Default,
      sortable: true,
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: `0 0 100%`,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
        },
      },
    },
    status: {
      id: 'status',
      label: $localize`Status`,
      type: DynamicTableColumnTypes.Default,
      sortable: true,
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: `0 0 33%`,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
        },
      },
    },
    qualification: {
      id: 'qualification',
      label: $localize`Qualification`,
      type: DynamicTableColumnTypes.Default,
      sortable: true,
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: `0 0 33%`,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 2,
        },
      },
    },
    id: {
      id: 'id',
      label: $localize`ID Number`,
      type: DynamicTableColumnTypes.Default,
      sortable: true,
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: `0 0 33%`,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
        },
      },
    },
    startDate: {
      id: 'startDate',
      label: $localize`Start date`,
      type: DynamicTableColumnTypes.Template,
      columnType: 'date',
      props: {
        path: 'startDate',
      },
      sortable: true,
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: `0 0 33%`,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
        },
      },
    },
    endDate: {
      id: 'endDate',
      label: $localize`End date`,
      type: DynamicTableColumnTypes.Template,
      columnType: 'date',
      props: {
        path: 'endDate',
      },
      sortable: true,
      layout: {
        [DynamicTableBreakpoints.DEFAULT]: {
          flex: `0 0 33%`,
        },
        [DynamicTableBreakpoints.SM]: {
          flex: 1,
        },
      },
    },
  },
  sort: {
    active: 'name',
    direction: DynamicTableSortDirection.Asc,
  },
  pagination: DEFAULT_PAGINATION,
};
